import { isAllowCapture, multiplyVec2, invert } from '@antv/g-base';
function invertFromMatrix(v, matrix) {
    if (matrix) {
        var invertMatrix = invert(matrix);
        return multiplyVec2(invertMatrix, v);
    }
    return v;
}
function getRefXY(element, x, y) {
    // @ts-ignore
    var totalMatrix = element.getTotalMatrix();
    if (totalMatrix) {
        var _a = invertFromMatrix([x, y, 1], totalMatrix), refX = _a[0], refY = _a[1];
        return [refX, refY];
    }
    return [x, y];
}
// æ¾ååçæ£æµï¼åªæéè¿æ£æµæè½ç»§ç»­æ¾å
function preTest(element, x, y) {
    // @ts-ignore
    if (element.isCanvas && element.isCanvas()) {
        return true;
    }
    // ä¸åè®¸è¢«æ¾åï¼åè¿å null
    // @ts-ignore
    if (!isAllowCapture(element) || element.cfg.isInView === false) {
        return false;
    }
    if (element.cfg.clipShape) {
        // å¦æå­å¨ clip
        var _a = getRefXY(element, x, y), refX = _a[0], refY = _a[1];
        if (element.isClipped(refX, refY)) {
            return false;
        }
    }
    // @ts-ignore ï¼è¿ä¸ªå°æ¹è°ç¨è¿äºé¢ç¹
    var bbox = element.cfg.cacheCanvasBBox || element.getCanvasBBox();
    // å¦ææ²¡æç¼å­ bboxï¼åè¯´æä¸å¯è§
    // æ³¨éæçè¿æ®µå¯è½ä¼å éæ¾åï¼ä¸é¢çè¯­å¥æ¹åæ const bbox = element.cfg.cacheCanvasBBox;
    // è¿æ¶åçæ¾ååè®¾å¾å½¢/åç»å¨ä¸ä¸æ¬¡ç»å¶é½å¨è§çªåï¼ä½æ¯ä¸é¢å·²ç»å¤å®äº isInView æä»¥æä¹ä¸å¤§
    // ç°å¨è¿è°ç¨ element.getCanvasBBox(); ä¸ä¸ªå¾å¤§çåå æ¯ä¾¿äºååæµè¯
    // if (!bbox) {
    //   return false;
    // }
    if (!(x >= bbox.minX && x <= bbox.maxX && y >= bbox.minY && y <= bbox.maxY)) {
        return false;
    }
    return true;
}
// è¿ä¸ªæ¹æ³å¤åäº g-base ç getShape
export function getShape(container, x, y) {
    // æ²¡æéè¿æ£æµï¼åè¿å null
    if (!preTest(container, x, y)) {
        return null;
    }
    var shape = null;
    var children = container.getChildren();
    var count = children.length;
    for (var i = count - 1; i >= 0; i--) {
        var child = children[i];
        if (child.isGroup()) {
            shape = getShape(child, x, y);
        }
        else if (preTest(child, x, y)) {
            var curShape = child;
            var _a = getRefXY(child, x, y), refX = _a[0], refY = _a[1];
            // @ts-ignore
            if (curShape.isInShape(refX, refY)) {
                shape = child;
            }
        }
        if (shape) {
            break;
        }
    }
    return shape;
}
//# sourceMappingURL=hit.js.map